/**
 * Snurky: sposta il link popup tabella taglie
 */
(function () {
  function moveSizeGuidePopup() {
    var popupOpener = document.querySelector('.product-popup-modal__opener');
    if (!popupOpener) return;
    var popupBtn = popupOpener.querySelector('.product-popup-modal__button');
    if (!popupBtn) return;
    var sizeLabel = null;
    var labels = document.querySelectorAll('legend.form__label, label.form__label');
    labels.forEach(function (el) {
      var text = el.textContent.trim().toLowerCase();
      if (text === 'größe' || text.startsWith('größe')) sizeLabel = el;
    });
    if (!sizeLabel) return;
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'snurky-size-trigger';
    trigger.textContent = popupBtn.textContent.trim() || 'Größentabelle';
    trigger.setAttribute('aria-haspopup', 'dialog');
    var modalId = popupOpener.getAttribute('data-modal');
    trigger.addEventListener('click', function () {
      var modal = document.querySelector(modalId);
      if (modal && modal.show) modal.show(trigger);
      else if (modal) { modal.removeAttribute('hidden'); modal.setAttribute('open', ''); }
    });
    sizeLabel.classList.add('snurky-legend-flex');
    sizeLabel.appendChild(trigger);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', moveSizeGuidePopup);
  else moveSizeGuidePopup();
  document.addEventListener('shopify:section:load', moveSizeGuidePopup);
})();

/**
 * Snurky: Footer Accordion - solo mobile
 */
(function() {
  function initFooterAccordion() {
    if (window.innerWidth > 749) return;
    var menuBlocks = document.querySelectorAll('.footer-block--menu');
    menuBlocks.forEach(function(block) {
      var heading = block.querySelector('.footer-block__heading');
      var list = block.querySelector('.footer-block__details-content');
      if (!heading || !list) return;
      if (heading.dataset.accordion) return;
      heading.dataset.accordion = '1';
      list.classList.remove('is-open');
      heading.addEventListener('click', function() {
        var isOpen = heading.classList.contains('is-open');
        document.querySelectorAll('.footer-block--menu .footer-block__heading.is-open').forEach(function(h) {
          h.classList.remove('is-open');
          var l = h.closest('.footer-block--menu').querySelector('.footer-block__details-content');
          if (l) l.classList.remove('is-open');
        });
        if (!isOpen) {
          heading.classList.add('is-open');
          list.classList.add('is-open');
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFooterAccordion);
  else initFooterAccordion();
  document.addEventListener('shopify:section:load', initFooterAccordion);
})();

/**
 * Snurky: Animazioni testi globali su tutte le pagine
 */
(function() {
  var SELECTORS = [
    /* Image with text */
    '.image-with-text__heading',
    '.image-with-text__text',
    /* Rich text */
    '.rich-text__heading',
    '.rich-text__text',
    /* Featured collection */
    '.collection__title',
    /* Multicolumn */
    '.multicolumn-card__title',
    '.multicolumn-card__info',
    /* Slideshow */
    '.slideshow__text-wrapper h2',
    '.slideshow__text-wrapper p',
    /* Banner */
    '.banner__heading',
    '.banner__text',
    /* Product info */
    '.product__title',
    '.product-description',
    /* Blog */
    '.article-card__title',
    /* Generic */
    '.shopify-section .title',
    '.shopify-section .subtitle'
  ];

  function initTextAnimations() {
    var els = document.querySelectorAll(SELECTORS.join(','));
    els.forEach(function(el) {
      if (el.closest('.slh')) return; /* Salta landing custom */
      if (el.dataset.snurkyAnim) return; /* Gia animato */
      el.dataset.snurkyAnim = '1';
      el.classList.add('snurky-text-animate');
    });

    if (!window._snurkyObserver) {
      window._snurkyObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            window._snurkyObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
    }

    document.querySelectorAll('.snurky-text-animate:not(.visible)').forEach(function(el) {
      window._snurkyObserver.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(initTextAnimations, 300); });
  } else {
    setTimeout(initTextAnimations, 300);
  }
  document.addEventListener('shopify:section:load', initTextAnimations);
})();